<template>
  <div class="mb-3">
    <v-card dark class="elevation-5" style="border-radius: 16px; width: 250px">
      <v-list class="py-0" style="background-color: #000">
        <v-list-tile>
          <v-list-tile-title
            style="text-align: center; font-size: 20px; color: white"
            >MERCHANT MANAGEMENT</v-list-tile-title
          >
        </v-list-tile>
      </v-list>
      <v-list class="py-0" style="overflow: hidden">
        <v-list-group
          v-for="item in filteredSidebar"
          v-model="item.active"
          :key="item.title"
          :prepend-icon="item.action"
          no-action
        >
          <v-list-tile slot="activator">
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            v-for="subItem in filterSubSidebar(item)"
            :key="subItem.title"
            :to="subItem.url"
          >
            <v-list-tile-content>
              <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>
      </v-list>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      items: [
        {
          action: "storefront",
          permission_name: "approve_list",
          title: "Food Merchant",
          items: [
            {
              title: "Contact Store",
              permission_name: "contact_approve",
              url: "/weserve_admin_login/-/mainmerchant/contactstoreapprove",
            },
            {
              title: "Document Approve",
              permission_name: "document_approve",
              url: "/weserve_admin_login/-/mainmerchant/documentapprove",
            },
            {
              title: "Store Information",
              permission_name: "store_approve",
              url: "/weserve_admin_login/-/mainmerchant/storeapprove",
            },
            {
              title: "Edit Store approve",
              permission_name: "store_edit_approve",
              url: "/weserve_admin_login/-/mainmerchant/editstoreapprove",
            },
            {
              title: "Store Registration",
              permission_name: "store_status",
              url: "/weserve_admin_login/-/mainmerchant/storeregistrantion",
            },
            {
              title: "Approve Events Log",
              permission_name: "approve_log",
              url: "/weserve_admin_login/-/mainmerchant/userlogapproval",
            },
            {
              title: "Action Events Log",
              permission_name: "event_log",
              url: "/weserve_admin_login/-/mainmerchant/event-action",
            },
          ],
        },
        {
          action: "liquor",
          permission_name: "dine_in_merchant",
          title: "Dine-in Merchant",
          items: [
            {
              title: "Connect User&Store",
              permission_name: "store_manage_user",
              url: "/weserve_admin_login/-/mainmerchant/store_user_manage",
            },
          ],
        },
        {
          action: "notifications_active",
          permission_name: "notification",
          title: "Ads.",
          items: [
            {
              title: "Merchant News",
              permission_name: "merchant_news",
              url: "/weserve_admin_login/-/mainmerchant/newsnotification",
            },
            {
              title: "Merchant Banners",
              permission_name: "merchant_news",
              url: "/weserve_admin_login/-/mainmerchant/bannersnotification",
            },
          ],
        },
        // {
        //   action: "person",
        //   permission_name: "user_list",
        //   title: "User",
        //   items: [
        //     {
        //       title: "User List",
        //       permission_name: "edit_view",
        //       url: "/weserve_admin_login/-/mainmerchant/userlist",
        //     },
        //   ],
        // },
      ],
    };
  },
  computed: {
    ...mapState({
      permission: (state) => state.permission,
    }),
    filteredSidebar() {
      return this.items.filter((val) => {
        for (let val2 in this.permission.main_menu.merchant_manage) {
          if (val2 == val.permission_name) return val;
        }
      });
    },
  },
  methods: {
    filterSubSidebar(item) {
      return item.items.filter((val) => {
        for (let val2 in this.permission.main_menu.merchant_manage[
          item.permission_name
        ]) {
          if (val2 == val.permission_name) return val;
        }
      });
    },
  },
};
</script>
